import { AuthenticationService } from './../../servicios/authentication.service';
import { Component, OnInit, EventEmitter, ViewChild, HostListener } from "@angular/core";
import { CortesService } from '../../servicios/cortes.service';
import { Cortes, CatSucursales, Aguas, BuscaTramite } from '../../entidades/entidades';
import { CatSucursalService } from "../../servicios/cat-sucursal.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { AguasService } from "../../servicios/aguas.service";

@Component({
  selector: 'app-caja',
  templateUrl: './caja.component.html',
  styleUrls: ['./caja.component.css']
})
export class CajaComponent implements OnInit {
  apertura: boolean = false;
  abreCaja: boolean = false;
  usuario: any;
  cortes: Cortes
  sucursal: any
  fecha_apertura: Date
  cajaAgua: boolean = false;
  muestraMensaje = new MuestraMensaje();

  public buscaApertura$ = new EventEmitter<Cortes>();
  public catSucursal: CatSucursales;
  public aguas$ = new EventEmitter<Aguas>();
  public solicitud$ = new EventEmitter<BuscaTramite>();
  public aguasVacio: Aguas;
  public solicitudVacio: BuscaTramite;

  constructor(
    private CortesService: CortesService,
    private catSucursalService: CatSucursalService,
    private aguasService: AguasService,
    private authenticationService:AuthenticationService
  ) {
  
  }
  async ngOnInit() { 
    await this.authenticationService.getUserByToken();
    this.usuario = this.authenticationService.currentUserValue;
    let cortes = new Cortes();
    cortes.idUsuarioCajero = this.usuario.id;
    this.getCortes(cortes);
  }
   // Escuchar el evento de teclado
   @HostListener('document:keydown', ['$event'])
   handleKeyboardEvent(event: KeyboardEvent) {
     const key = event.key.toLowerCase();
    if (key === 'arrowright') {
      // Flecha derecha, cambia a "Servicios"
      this.cajaAgua = true;
      console.log('Cambio a Servicios');
    } else if (key === 'arrowleft') {
      // Flecha izquierda, cambia a "Consumo"
      this.cajaAgua = false;
      console.log('Cambio a Consumo');
    }
   }
  async getCortes(Cortes: Cortes) {
    try {
      console.log('Inmprime: ', Cortes);
      var datoRetorno = await this.CortesService
        .getBusquedas(Cortes)
        .toPromise();

      console.log("Detalle corte", datoRetorno);
      this.fecha_apertura = datoRetorno.fechaApertura;

      if (datoRetorno.id == 0) {
        this.apertura = true;
        this.cortes = datoRetorno;
        this.abreCaja = false;
      } else {
        console.log('Se abre Grid');
        this.abreCaja = false;
        //Carga Apertura de Corte si la fecha de apertura es distinta a la de hoy
        let buscaApertura = Cortes;
        buscaApertura.idUsuarioCajero = Cortes.idUsuarioCajero;
        this.buscaApertura$.emit(buscaApertura);
        console.log('Cajero : ', buscaApertura.idUsuarioCajero);
      }

      this.getSucursal(datoRetorno.idSucursal);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCortes");
    }
  }

  childApertura(Cortes: Cortes) {
    try {
      console.log("retorna childAPertura", Cortes);
      if (Cortes.idUsuarioCajero != null) {
        this.apertura = false;
        this.abreCaja = true;
      } else {
        this.apertura = true;
        this.abreCaja = false;
      }
      this.getSucursal(Cortes.idSucursal);
      console.log('Corte     1: ', Cortes);

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por chilApertura");
    }
  }

  childCorteSesion(Cortes: Cortes) {
    try {
      console.log("retorna childCorte", Cortes);
      this.buscaApertura$.emit(null);
      if (Cortes.id != 0) {
        this.abreCaja = true;
      } else {
        this.apertura = true;
        this.abreCaja = false;
      }

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por childCorteSesion");
    }
  }

  async getSucursal(id: number) {
    try {
      if (id == null) {
        const datoRetorno = await this.catSucursalService.getSingle(0).toPromise();
        this.catSucursal = datoRetorno;
        console.log('Sucursal: ', datoRetorno);
        this.sucursal = datoRetorno.descripcion;
      } else {
        const datoRetorno = await this.catSucursalService.getSingle(id).toPromise();
        this.catSucursal = datoRetorno;
        console.log('Sucursal: ', datoRetorno);
        this.sucursal = datoRetorno.descripcion;
      }

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatSucursal");
    }
  }

  async childAguaBuscaCuentas(aguas: Aguas) {
    try {
      console.log("Retorno el hijo childAguaBuscaCuentas ", aguas);

      await this.aguas$.emit(aguas);

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por childAguas");
    }
  }

  async childBuscaDetalleSolicitud(buscaDetalleSolicitud: BuscaTramite) {
    try {
      console.log("Retorno el hijo childBuscaDetalleSolicitud ", buscaDetalleSolicitud);

      await this.solicitud$.emit(buscaDetalleSolicitud);

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por childBuscaDetalleSolicitud");
    }
  }

}